import api from "./api";
import staleness from "./staleness";
import download from "./download";

const middlewares = [staleness, api, download];

export default middlewares;
